import {
  BusFill18Icon,
  CapacitySeatFill18Icon,
} from "@vygruppen/spor-icon-react";
import { FC } from "react";
import { DataMarker } from "shared/components/dataMarker/DataMarker";
import { DropsBadge, Flex, HStack, Text, tokens } from "shared/components/Spor";
import { useThemeSemantic } from "shared/theme/themeSemantic";

import { MarkerToRender } from "features/CenterContent/RoleContent/AlternativeTransport/DecisionSupport/components/AreaChart/components/markerLayer/utils";
import { CHART_CONFIG } from "features/CenterContent/RoleContent/AlternativeTransport/DecisionSupport/components/AreaChart/constants";
import {
  formatTime,
  getBusCount,
} from "features/CenterContent/RoleContent/AlternativeTransport/DecisionSupport/components/AreaChart/utils";

interface ChartMarkerProps {
  marker: MarkerToRender;
  xMax: number;
  badgeY: number;
}

export const ChartMarker: FC<ChartMarkerProps> = ({ marker, xMax, badgeY }) => {
  const theme = useThemeSemantic(marker.variant);

  return (
    <DataMarker
      cx={marker.cx}
      cy={marker.cy}
      xMax={xMax}
      badgeY={badgeY}
      lineColor={theme.colorSemantic}
      outlineColor={theme.colorSemanticOutline}
      markerConfig={CHART_CONFIG.marker}
      bubbleContent={
        <HStack display="flex" gap={0}>
          <CapacitySeatFill18Icon />
          <Text fontWeight="bold" fontSize="xs">
            {marker.passengers}
          </Text>
          <Text
            fontWeight="bold"
            fontSize="xs"
            ml={tokens.default.size.spacing[1]}
          >
            /{" "}
          </Text>
          <BusFill18Icon mt="-1px" ml={tokens.default.size.spacing[1]} />
          <Text
            fontWeight="bold"
            fontSize="xs"
            ml={tokens.default.size.spacing[0.5]}
          >
            {getBusCount({
              stretch: "total",
              date: marker.date,
              passengers: marker.passengers,
            })}
          </Text>
        </HStack>
      }
      labelContent={
        <Flex flexDirection="column" alignItems="center" height="100%">
          <DropsBadge semantics={marker.variant}>
            {formatTime(marker.date)}
          </DropsBadge>
          <Text fontSize="xs" color={theme.colorSemanticTextSecondary}>
            {marker.type}
          </Text>
        </Flex>
      }
      measureDeps={[
        marker.passengers,
        getBusCount({
          stretch: "total",
          date: marker.date,
          passengers: marker.passengers,
        }),
      ]}
      ariaLabel={`Marker at ${formatTime(marker.date)} - ${marker.type}`}
    />
  );
};
